<div>
  <div
    class="d-block w-100 workspace-dashboard-container"
    [ngClass]="{ 'comment-right-panel-expanded': isCommentPageCommentExpanded }">
    <!-- Loading placeholders, the same grid skeleton as the campaign and project lists. -->
    @if (!isLoaded && !isError) {
      <div class="pt-4 px-3 workspace-skeleton">
        <mtm-grid-skeleton
          [borderRadius]="6"
          [gridCount]="5"
          [widthSizeInPixels]="320"
          [HeightSizeInPixels]="210"></mtm-grid-skeleton>
      </div>
    }
    <div class="py-4 mx-0 workspace-list px-3">
      <!--
    <div *ngIf="canCreateWorkspace" class="d-flex col mb-4" [style.max-width]="'200px'" [style.min-width]="'200px'">
      <button class="workspace-btn w-100" (click)="createWorkspace()">
        <div class="circle-div">
          <i class="fa fa-plus d-flex" aria-hidden="true"></i>
        </div>
        <h6 class="_700 f-10 mt-3 line-height text-uppercase" [style.color]="'#898C98'">{{'dashboard_createNewWorkspace' | translate }}</h6>
      </button>
    </div>
    -->
      <div class="d-flex justify-content-center align-items-center w-75" *ngIf="isError">
        <span class="_600 f-12">{{ 'dashboard_somethingWentWrong' | translate }}</span>
      </div>
      <div
        class="pointer workspace"
        *ngFor="let item of workSpaces; let i = index"
        [ngClass]="{
          'single-ws': workSpaces.length === 1 || workSpaces.length === 2,
        }"
        (click)="goToCampaignDrive(item)">
        <div class="card-img">
          <img
            *ngIf="item.avatarUrl"
            class="image-style"
            [src]="item.avatarUrl | cacheBusterImage: cacheBuster"
            alt=""
            (error)="item.avatarUrl = null" />
          <span
            *ngIf="!item.avatarUrl"
            class="c-full-white workspace-name-text text-uppercase h-100 w-100"
            [style.backgroundColor]="timelineService.getColorFromName(item.name)">
            {{ item.name | slice: 0 : 2 }}
          </span>
        </div>
        <div class="card-block d-flex">
          <div class="col position-relative">
            <div class="row mb-1" [style.max-width]="'180px'" [style.min-width]="'180px'">
              <div class="col">
                <span class="f-10 _700 company-name text-uppercase" [style.color]="'#898C98'">{{
                  item.brandName
                }}</span>
              </div>
            </div>
            <div class="row" [style.height]="'45px'">
              <div class="col">
                <span
                  class="f-14 _700 c-full-white workspace-name"
                  [ngbTooltip]="shouldShowEllipsis(item.name) ? item.name : null">
                  {{ item.name }}
                </span>
              </div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div class="drive-campaign-circle me-2">{{ item.numberOfDriveCampaign }} </div>
              <span class="f-10 _400 c-full-white text-capitalize me-4">{{ 'campaigns' | translate }}</span>

              <div class="drive-campaign-circle me-2">{{ item.numberOfStandaloneProjects }} </div>
              <span class="f-10 _400 c-full-white text-capitalize">{{ 'projects' | translate }}</span>
            </div>
            <div
              class="position-absolute pointer"
              [style.height]="'20px'"
              style="top: -5px; right: 0"
              (click)="$event.stopImmediatePropagation()">
              <div
                *ngIf="canManageWorkspace || canUpdateWorkspace || canDeleteWorkspace"
                ngbDropdown
                autoCloseDropdown
                class="dropdown"
                container="body"
                placement="bottom-right">
                <div class="dropdown-toggle-container" ngbDropdownToggle>
                  <div class="three-dot-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <div ngbDropdownMenu class="dropdown-menu-start arrow_box" aria-labelledby="dropdownMenuLink">
                  <div class="col options hover-text">
                    <div
                      *ngIf="canManageWorkspace || canUpdateWorkspace"
                      class="col pointer p-0 d-flex align-items-center my-3"
                      (click)="editWorkspace(item)">
                      <i [style.color]="'#181E39'" class="_500 fa fa-pencil fa-lg" aria-hidden="true"></i>
                      <span class="ms-2 f-10 _700 text-uppercase"> {{ 'settings' | translate }}</span>
                    </div>
                    <!--
                <div class="col pointer p-0 d-flex align-items-center my-3" (click)="!item.isFavorite ? markAsFavorite(item) : removeFavorite(item)">
                  <i *ngIf="!item.isFavorite" class="_500 fa fa-star-o fa-lg" [style.color]="'#181E39'"
                    aria-hidden="true"></i>
                  <i *ngIf="item.isFavorite" class="_500 fa fa-star fa-lg " [style.color]="'#ffca4c'"
                    aria-hidden="true"></i>
                  <span class="ms-2 f-10 _700 text-uppercase"> {{ (!item.isFavorite ? 'markAsFavorite' : 'removeFavorite') | translate }}</span>
                </div>
                -->
                    <div
                      *ngIf="canManageWorkspace || canDeleteWorkspace"
                      class="col pointer p-0 d-flex align-items-center my-3"
                      (click)="deleteWorkspace(item)">
                      <i [style.color]="'#181E39'" class="_500 fa fa-trash-o fa-lg" aria-hidden="true"></i>
                      <span class="ms-2 f-10 _700 text-uppercase"> {{ 'delete' | translate }} </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #searchPanel>
        <div class="d-flex align-items-center justify-content-between search-panel">
          <div class="position-relative search-container ms-lg-auto">
            <input
              [(ngModel)]="worskspaceSearch"
              class="search-box ps-2 pe-4"
              (ngModelChange)="searchWorkSpace()"
              type="text"
              [placeholder]="'search' | translate" />
            <i class="fa fa-search search-icon" aria-hidden="true"></i>
          </div>
          <button
            class="btn btn-orange text-uppercase position-relative btn-new-workspace"
            *ngIf="canCreateWorkspace"
            (click)="createWorkspace()">
            <i class="p-1 fa fa-plus" aria-hidden="true"></i>
            <span>{{ 'workspace_createNewWorkspace' | translate }}</span>
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
